import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentLoading from './AsyncComponentLoading';
import AsyncComponentError from './AsyncComponentError';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingComponent = props => /*#__PURE__*/_jsx(AsyncComponentLoading, Object.assign({}, props));
LoadingComponent.displayName = 'AsyncInboxZeroState';
const AsyncInboxZeroState = Loadable({
  loader: () => import( /* webpackChunkName: "inbox-zero-state" */'../../unified-inbox/components/zero-states/InboxZeroState'),
  LoadingComponent,
  ErrorComponent: AsyncComponentError
});
export default AsyncInboxZeroState;